export default __webpack_public_path__ + "static/media/Abby.6df2f246.jpg";